import { useQuery } from '@cqrs/vue-composables-cqrs'
import * as q from '@DataSharing/Shares/queries-core'
import { isRef, ref, Ref } from 'vue'
export function useAccessShareQueryV1(id?: string | Ref<string>, ) {
	const _id = isRef<string>(id) ? id : ref<string>(id)
	const result = {
		id: _id,
		...useQuery(() => new q.AccessShareQueryV1(_id.value))
	}
	return {
		...result,
		runAccessShareQueryV1: result.run,
		modelAccessShareQueryV1: result.model,
	}
}

export function useActiveSharesQueryV1(organizationUnitId?: number | Ref<number>, ) {
	const _organizationUnitId = isRef<number>(organizationUnitId) ? organizationUnitId : ref<number>(organizationUnitId)
	const result = {
		organizationUnitId: _organizationUnitId,
		...useQuery(() => new q.ActiveSharesQueryV1(_organizationUnitId.value))
	}
	return {
		...result,
		runActiveSharesQueryV1: result.run,
		modelActiveSharesQueryV1: result.model,
	}
}

export function useDataShareEmailsProvidersQueryV1(organizationUnitId?: string | Ref<string>, workspaceId?: string | null | Ref<string | null>, projectId?: string | null | Ref<string | null>, ) {
	const _organizationUnitId = isRef<string>(organizationUnitId) ? organizationUnitId : ref<string>(organizationUnitId)
	const _workspaceId = isRef<string | null>(workspaceId) ? workspaceId : ref<string | null>(workspaceId)
	const _projectId = isRef<string | null>(projectId) ? projectId : ref<string | null>(projectId)
	const result = {
		organizationUnitId: _organizationUnitId,
		workspaceId: _workspaceId,
		projectId: _projectId,
		...useQuery(() => new q.DataShareEmailsProvidersQueryV1(_organizationUnitId.value, _workspaceId.value, _projectId.value))
	}
	return {
		...result,
		runDataShareEmailsProvidersQueryV1: result.run,
		modelDataShareEmailsProvidersQueryV1: result.model,
	}
}

export function useEmailsAndGroupsQueryV1(organizationUnitId?: string | Ref<string>, workspaceId?: string | null | Ref<string | null>, projectId?: string | null | Ref<string | null>, emailsProviderName?: string | Ref<string>, ) {
	const _organizationUnitId = isRef<string>(organizationUnitId) ? organizationUnitId : ref<string>(organizationUnitId)
	const _workspaceId = isRef<string | null>(workspaceId) ? workspaceId : ref<string | null>(workspaceId)
	const _projectId = isRef<string | null>(projectId) ? projectId : ref<string | null>(projectId)
	const _emailsProviderName = isRef<string>(emailsProviderName) ? emailsProviderName : ref<string>(emailsProviderName)
	const result = {
		organizationUnitId: _organizationUnitId,
		workspaceId: _workspaceId,
		projectId: _projectId,
		emailsProviderName: _emailsProviderName,
		...useQuery(() => new q.EmailsAndGroupsQueryV1(_organizationUnitId.value, _workspaceId.value, _projectId.value, _emailsProviderName.value))
	}
	return {
		...result,
		runEmailsAndGroupsQueryV1: result.run,
		modelEmailsAndGroupsQueryV1: result.model,
	}
}

export function useResourceSharesQueryV1(resourceProviderName?: string | Ref<string>, resourceId?: string | Ref<string>, ) {
	const _resourceProviderName = isRef<string>(resourceProviderName) ? resourceProviderName : ref<string>(resourceProviderName)
	const _resourceId = isRef<string>(resourceId) ? resourceId : ref<string>(resourceId)
	const result = {
		resourceProviderName: _resourceProviderName,
		resourceId: _resourceId,
		...useQuery(() => new q.ResourceSharesQueryV1(_resourceProviderName.value, _resourceId.value))
	}
	return {
		...result,
		runResourceSharesQueryV1: result.run,
		modelResourceSharesQueryV1: result.model,
	}
}

export function useShareNotificationQueryV1(id?: string | Ref<string>, ) {
	const _id = isRef<string>(id) ? id : ref<string>(id)
	const result = {
		id: _id,
		...useQuery(() => new q.ShareNotificationQueryV1(_id.value))
	}
	return {
		...result,
		runShareNotificationQueryV1: result.run,
		modelShareNotificationQueryV1: result.model,
	}
}

export function useShareQueryV1(resourceProviderName?: string | Ref<string>, resourceId?: string | Ref<string>, id?: string | Ref<string>, ) {
	const _resourceProviderName = isRef<string>(resourceProviderName) ? resourceProviderName : ref<string>(resourceProviderName)
	const _resourceId = isRef<string>(resourceId) ? resourceId : ref<string>(resourceId)
	const _id = isRef<string>(id) ? id : ref<string>(id)
	const result = {
		resourceProviderName: _resourceProviderName,
		resourceId: _resourceId,
		id: _id,
		...useQuery(() => new q.ShareQueryV1(_resourceProviderName.value, _resourceId.value, _id.value))
	}
	return {
		...result,
		runShareQueryV1: result.run,
		modelShareQueryV1: result.model,
	}
}

export function useSharesForEmailQueryV1(email?: string | Ref<string>, ) {
	const _email = isRef<string>(email) ? email : ref<string>(email)
	const result = {
		email: _email,
		...useQuery(() => new q.SharesForEmailQueryV1(_email.value))
	}
	return {
		...result,
		runSharesForEmailQueryV1: result.run,
		modelSharesForEmailQueryV1: result.model,
	}
}

